export default "__VITE_ASSET__5576af87__"